export const SURVEY_LABEL_TYPES: ReadonlyArray<{
  value: string;
  label: string;
}> = [
  { value: 'CPO', label: 'CPO - NP,LEGL.' },
  { value: 'CPO_DESC', label: 'CPO - Desc (CofA)' },
  { value: 'CPO_OP', label: 'CPO - Fieldnotes (OP)' },
  { value: 'CPO_PLAN', label: 'CPO - Plan (Putaway)' },
  { value: 'CPO_ROAD', label: 'CPO - Notation (Road)' },
  { value: 'LTO', label: 'LTO - GAZ,LGD,MISC' },
  { value: 'LTO_AP', label: 'LTO - Application' },
  { value: 'LTO_PLAN', label: 'LTO - Plan (current)' },
  { value: 'LTO_PLANOLD', label: 'LTO - Plan (non-curr)' },
  { value: 'LTO_ROAD', label: 'LTO - Road' },
  { value: 'LTO_SINFO', label: 'LTO - SurveyInfo (RE)' },
] as const;

const surveyLabelTypeMap = new Map(
  SURVEY_LABEL_TYPES.map((t) => [t.value, t.label]),
);

/**
 * Resolves a survey label code to its human-readable type label.
 * Returns the code itself if no mapping is found, or null if code is null.
 */
export function getSurveyLabelTypeLabel(
  code: string | null | undefined,
): string | null {
  if (!code) return null;
  return surveyLabelTypeMap.get(code) ?? code;
}

/**
 * Maps WFS/WMS type names (from GeoServer feature IDs) to display layer names.
 * Used to resolve the actual map layer from the WMS GetFeatureInfo response.
 */
const wfsTypeToDisplayLayer = new Map<string, string>([
  ['LTO', 'SURVEY_LABEL'],
  ['VMAP_LV_CPO', 'SURVEY_LABEL'],
  ['RETIRED_SURVEY_LABEL', 'RETIRED_SURVEY_LABEL'],
  ['PLAN', 'PLAN'],
  ['BUA_PROPOSED_ANNO', 'BUA_PROPOSED_ANNO'],
  ['ROADS_CORP_SP_WITHOUT_FN', 'ROADS_CORP_SP_WITHOUT_FN'],
  ['ROADS_CORP_SP_WITH_FN', 'ROADS_CORP_SP_WITH_FN'],
  ['ROADS_CORP_CONTROL_PLANS', 'ROADS_CORP_CONTROL_PLANS'],
]);

/**
 * Resolves a WMS/WFS type name to the display layer name.
 * e.g. 'VMAP_LV_CPO' -> 'SURVEY_LABEL', 'LTO' -> 'SURVEY_LABEL'
 */
export function getDisplayLayerName(
  wmsType: string | null | undefined,
): string | null {
  if (!wmsType) return null;
  return wfsTypeToDisplayLayer.get(wmsType) ?? wmsType;
}
